import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function Community() {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      setLoading(false);
    }
  }, [user]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-4">Community</h1>
      <p>Community features coming soon...</p>
    </div>
  );
} 